import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core'
import { LinkModel, TabsModel } from '@flocasts/experience-service-types'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'

@Component({
  selector: 'flo-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss', './styles/favorites-page-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsComponent {
  @Input() tabsModel: TabsModel

  @Output() tabClick = new EventEmitter<LinkModel>()

  /**
   * If a url is provided, the link component will automatically route to that url via the floCustomLinkDirective.
   * However, by design, sometimes the url will be null.
   * In this case, we will want to emit up so we can make an API request with the api_call property instead.
   * @param link The link model.
   */
  handleTabClick(link: LinkModel) {
    if (!link.url) {
      this.tabClick.emit(link)
    }
  }

  trackById = trackById
}
